// extracted by mini-css-extract-plugin
export var paragraph = "t_bm";
export var paragraphTertiary = "t_bJ";
export var paragraphWhite = "t_bH";
export var variant1 = "t_by";
export var variant2 = "t_bz";
export var variant3 = "t_bB";